import { Component, Inject } from '@angular/core';
import { TokenStorageService } from '../../services/auth-user-service/token-storage.service';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../services/language.service';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { ISPI } from '../../ticketing-cercador/ticketing.interfaces';
import { TicketingService } from '../../services/ticketing-service/ticketing.service';
import { ProjectsService } from '../../services/projects-proposals-service/projects-proposals.service';

@Component({
  selector: 'dialog-ticketing',
  templateUrl: 'dialog.component.ticketing.html',
  styleUrls: ['dialog.component.ticketing.css'],
  providers: [ TicketingService, ProjectsService]
})
export class DialogTicketing {
  public possibleTipus: Array<any>;
  public possibleSubTipus: Array<any>;
  public llistaParticipants: Array<any>;
  public userInfo: any = {};
  
  public ticketingModel: ISPI = {
    'id': 0,
    'projecte_codi': '',
    'tipus': '',
    'id_tipus': null,
    'sub_tipus': '',
    'personal_id': '',
    'assumpte': '',
    'data_peticio': '',
    'hora': '',
    'acords': '',
    'data_acord': '',
    'data_denegacio': '',
    'estat': '',
    'filename': '',
    'file': null,
    'data_realitzacio': '',
    'urgencia': 0,
  };

  private file;
  public editTicketingData = Object.assign(
    this.ticketingModel
  );

  constructor(public translate: TranslateService, public languageService: LanguageService, public dialogRef: MatDialogRef<DialogTicketing>, private tokenStorage: TokenStorageService, public manageTicketsService: TicketingService, public dataService: ProjectsService, @Inject(MAT_DIALOG_DATA) public data: any){
    this.editTicketingData =  data;
    this.manageTicketsService.getAutocomplete("tipusTicket").subscribe(tipus => { 
      if (!this.userInfo.admin) {
        // Si no és admin, filtrem: només mantenim els que NO tenen view = 1
        this.possibleTipus = tipus.filter(t => t['view'] !== 1);
      } else {
        // Si és admin, ho veu tot
        this.possibleTipus = tipus;
      }
      this.manageTicketsService.getAutocomplete("subTipusTicket")
        .subscribe(subtipus => { this.possibleSubTipus = subtipus;
      });
     });

    this.userInfo = this.tokenStorage.getUser();

    if(data.personal_id == ""){
      data.nom = this.userInfo.name;
      data.personal_id = this.userInfo.id;
    }
  }

  get subTipusFiltrats() {
    if (!this.possibleSubTipus || !this.possibleTipus) {
      return [];
    }

    return this.possibleSubTipus.filter(st => st.id_tipus === this.editTicketingData.id_tipus);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  desar(): void {
    console.log(this.editTicketingData);
    if(this.editTicketingData.id_tipus == ''){alert(this.translate.instant('ticketingDialog.avisTipus'));return;}
    if(this.editTicketingData.sub_tipus == ''){alert(this.translate.instant('ticketingDialog.avisSubtipus'));return;}
    // NOTA: el model ISPI no té cap camp anomenat 'data' (existeix 'data_peticio').
    // Aquesta comprovació probablement s'hauria de fer sobre 'data_peticio'.
    if(this.editTicketingData.data_peticio == ''){alert(this.translate.instant('ticketingDialog.avisData'));return;}
    this.editTicketingData.tipus = this.possibleTipus.find(item => item.id == this.editTicketingData.id_tipus);
    this.dialogRef.close(this.editTicketingData);
  }

  close(): void {
    this.dialogRef.close(null);
  }

  public onFileChange(event){
    let reader = new FileReader();
    
    if(event.target.files && event.target.files.length > 0) {
      let file = event.target.files[0];
      reader.readAsDataURL(file);
      reader.onload = () => {
        if(file.size > 100000000){
          alert(this.translate.instant('ticketingDialog.avisMidaFitxer'));
          this.editTicketingData.filename = ''
          return;
        };
        this.editTicketingData.filename = file.name;
        this.editTicketingData.file = {
          filename: file.name,
          filetype: file.type,
          value: reader.result
        };
      };
    }else {this.editTicketingData.file = null;this.editTicketingData.filename = '';}
  }
  
    public desarFitxer(event,fitxer, path){
    event.preventDefault(); //!important evitar que la pàgina navegui al registre
    this.dataService.downloadFile(path, fitxer);
  }
}
